<template>
  <div>
    <div class="row justify--space-between align--center ma-0 mb-4">
      <h1 :style="{color: $themes.primary, textTransform: 'uppercase'}">{{ title }}</h1>
      <va-button @click="$router.push({ name: 'new-service' })" class="ma-0">{{ $t('services.new') }}</va-button>
    </div>

    <data-table-services class="mb-4"/>
  </div>
</template>

<script>
import DataTableServices from '../components/DataTableServices.vue'

export default {
  data: () => ({
    title: 'Serviços',
  }),
  components: {
    DataTableServices,
  },
}
</script>
